import {
  Box,
  BoxProps,
  ColorOptions,
  Icon,
  IconOptions,
  Image,
  ImageProps,
  Loader,
  Spacer,
  Text,
  TextProps
} from '@jfs/ui-new'
import { DrawerContentComponentProps, createDrawerNavigator } from '@react-navigation/drawer'
import { CommonActions, DrawerActions, ParamListBase } from '@react-navigation/native'
import type { StackScreenProps } from '@react-navigation/stack'
import { FC, Suspense, useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { SectionList } from 'react-native'
import { PayLaterIcon } from '../assets/images/svg/PayLaterIcon'
import Pluxee from '../assets/images/svg/Pluxee'
import { UpiIcon } from '../assets/images/svg/Upi'
import { CustomSwitch } from '../comps/CustomSwitch'
import { FallbackScreen } from '../comps/FallBackScreen'
import Footer from '../comps/Footer'
import { Header as MainHeader } from '../comps/Header'
import { PreventBack } from '../comps/PreventBackModal'
import { TOneHeader } from '../comps/TOneHeader'
import { ViewOffer } from '../comps/ViewOffer'
import { CardType } from '../data/models/Card'
import { UPIType } from '../data/models/UPI'
import { useLazyApiData, useStores } from '../data/store'
import Offers from '../screens/Offers'
import { MobileProcessing } from '../screens/PaymentProcesseing/MobileProcessing'
import {
  ROUTE_NAMES,
  addTwoDecimalZeroes,
  analyticsEvent,
  convertHexToRGBA,
  getPaymentMode,
  getPaymentModeList,
  isIFrame,
  isMobileDevice,
  routeEventMapper
} from '../utils'
import { useTemplate } from '../utils/ConfigProvider'
import {
  HEADER,
  PAYMENT_MODE_SUBTYPES,
  PAYMENT_SCREENS,
  getOfferSelectedPaymentType,
  pages,
  windowConfig
} from '../utils/constants'
import { staticStrings } from '../utils/string'
import { MenuData } from '../utils/types'

export const getMenuIconID = (path: any, theme: any): MenuData => {
  const defaultData = {
    text: 'JioMoney',
    image: undefined,
    imagepath: undefined,
    imagePathDisabled: undefined,
    iconComp: undefined,
  }
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require('../assets/images/upi.json'),
  }
  const menuList: any = {
    jiomoney: { text: 'JioMoney', image: 'LOGO' },
    [PAYMENT_SCREENS.wallet]: { text: 'Wallet', image: 'WALLET' },
    savedcard: { text: 'Saved Card', image: 'DEFAULT_CARD' },
    [PAYMENT_SCREENS.ccdccard]: { text: 'Credit / Debit Card', image: 'DEFAULT_CARD' },
    [PAYMENT_SCREENS.creditcard]: { text: 'Credit Card', image: 'DEFAULT_CARD' },
    [PAYMENT_SCREENS.debitcard]: { text: 'Debit Card', image: 'DEFAULT_CARD' },
    [PAYMENT_SCREENS.netbanking]: { text: 'Net Banking', image: 'BANK' },
    [PAYMENT_SCREENS.upi]: {
      text: 'Pay by any UPI app',
      desktopHeaderText: 'PAY THROUGH UPI QR CODE',
      imagepath: require('../assets/images/upi_color.png'),
      imagePathDisabled: require('../assets/images/upi_color.png'),
      iconComp: <UpiIcon size={24} selected={true} />,
      // rightComp: <Lottie options={defaultOptions} height={32} width={32} />,
    },
    [PAYMENT_SCREENS.sodexo]: {
      text: staticStrings.sodexoHeader,
      iconComp: <Pluxee width={32} height={32} />,
    },
    [PAYMENT_SCREENS.emi]: {
      text: 'EMI',
      image: 'DEFAULT_CARD',
    },
    [PAYMENT_SCREENS.paylater]: {
      text: 'Pay Later',
      iconComp: <PayLaterIcon size={24} color={theme?.brandColor} />,
    },
    offer: { text: 'Offers', image: 'LOGO' },
    [PAYMENT_SCREENS.jiopayfinancehub]: { text: 'JioPay EasyEMI', image: 'LOGO' },
    [PAYMENT_SCREENS.corporateNetbanking]: {
      text: 'Corporate Netbanking',
      image: 'BANK',
    },
    scanAndPay: { text: 'Scan and Pay', iconComp: <UpiIcon size={24} selected={true} /> },
  }

  console.log('menuList[path]', menuList[path])
  return { ...defaultData, ...(path ? menuList[path] : menuList.jiomoney) }
}

export const Header = ({
  onGoBack,
  showGoBack = true,
  title,
  hide = false,
  theme,
  rightTitle,
  onClickRightHeader,
  imagepath,
}: {
  onGoBack: () => void
  showGoBack?: boolean
  title: string
  hide?: boolean
  theme: any
  rightTitle?: string
  onClickRightHeader?: () => void
  imagepath?: any
}) => {
  if (hide) {
    return null
  }
  return (
    <Box
      direction="row"
      height={48}
      align="center"
      bg={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
      onPress={onGoBack}
      testID="go-back"
      underlayColor={convertHexToRGBA(theme?.brandColor, 60) as ColorOptions}>
      {showGoBack && (
        <Box underlayColor="LIGHTEST_GREY" paddingHorizontal={imagepath ? 8 : 16}>
          <Icon id="ARROW_BACK" color={convertHexToRGBA(theme?.bodyTextColor, 40) as ColorOptions} size={16} />
        </Box>
      )}
      {showGoBack && imagepath && (
        <Box pr={8}>
          <Image source={imagepath} width={18} height={18} resizeMode="contain" />
        </Box>
      )}
      {!showGoBack && <Spacer direction="horizontal" size={16} />}
      <Box flex={1} paddingRight={16} flexDirection="row" justifyContent="space-between">
        <Text
          color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
          fontFamily="jioType-medium"
          fontSize={12}>
          {title}
        </Text>
        <Box underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions} onPress={onClickRightHeader}>
          <Text
            color={theme?.brandColor as ColorOptions}
            textDecorationLine="underline"
            fontFamily="jioType-medium"
            fontSize={12}>
            {rightTitle}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

const CustomDrawerContent = (props: DrawerContentComponentProps<any>) => {
  const {
    netAmount,
    ruleAmount,
    theme,
    isOfferApplied,
    selectedOfferPMType,
    selectedOfferPMSubType,
    updateIsSubscriptionEnabled,
    isSubscriptionEnabled,
    allowPurchase,
  } = useStores((root) => ({
    netAmount: root?.transaction?.amount?.netAmount,
    theme: root?.config?.merchantTheme,
    isOfferApplied: root.transaction.isOfferApplied,
    selectedOfferPMType: root.transaction.selectedOfferPMType,
    selectedOfferPMSubType: root.transaction.selectedOfferPMSubType,
    updateIsSubscriptionEnabled: root.merchant.updateIsSubscriptionEnabled,
    isSubscriptionEnabled: root.merchant.subscription.isEnabled,
    allowPurchase: root.merchant.subscription.allowPurchase,
    ruleAmount: root.merchant.subscription.ruleAmountValue,
  }))
  const { state, navigation } = props

  const template = useTemplate()
  const isRowFlex = template?.headerFlexDirection === 'row'
  const brandColor = theme?.brandColor
  const textColor = theme?.bodyTextColor
  const RightArrow = (
    <Box {...styles.arrowContainerStyle(template)}>
      <Icon id={isRowFlex ? 'ARROW_RIGHT' : 'ARROW_LEFT'} color="PRIMARY" size={24} />
    </Box>
  )
  const MobileRightArrow = (
    <Box {...styles.arrowContainerStyle(template)}>
      <Icon
        id={isRowFlex ? 'ARROW_RIGHT' : 'ARROW_LEFT'}
        color={convertHexToRGBA(textColor, 40) as ColorOptions}
        size={24}
      />
    </Box>
  )

  const navItems: any = state.routes
    .filter((item) => item.name !== ROUTE_NAMES.offers)
    .map((item: any) => {
      return {
        key: item.key,
        name: item.name,
      }
    })

  let sectionData = [
    {
      title: 'SELECT PAYMENT OPTION',
      data: navItems,
    },
  ] as any

  if (isOfferApplied) {
    const paymentType = getOfferSelectedPaymentType(selectedOfferPMType, selectedOfferPMSubType)
    const prefered = navItems.filter((item: any) => getPaymentMode(item.name) === paymentType)
    const withoutOffer = navItems.filter((item: any) => getPaymentMode(item.name) !== paymentType)
    sectionData = [
      {
        title: 'PREFERRED PAYMENT OPTION',
        data: prefered,
      },
      {
        title: 'PAY WITHOUT OFFER',
        data: withoutOffer,
      },
    ]
  }

  const renderSectionHeader = ({ section }: { section: any }) => {
    return (
      <Box paddingHorizontal={16} paddingVertical={13}>
        <Text
          value={section.title}
          color={convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions}
          fontSize={12}
          fontFamily="jiotype-medium"
        />
      </Box>
    )
  }

  const renderItem = ({ item, section, index }: { item: any; section: any; index: number }) => {
    const routeName = getPaymentMode(item.name)
    const getMenuDetails = getMenuIconID(routeName, theme)
    const isSelected = state.routeNames[state.index] === item.name

    const selected = isSelected && false

    const iconColour = brandColor as ColorOptions
    console.log('state==>', item, routeName)
    return (
      <Box key={item.key} {...styles.menuViewContainer}>
        <Box
          testID={`paymentOption_${routeName}`}
          underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
          onPress={() => {
            analyticsEvent('payment_mode_selected', { mode: routeEventMapper[item.name] })
            navigation.dispatch({
              ...CommonActions.reset({
                index: 0,
                routes: [{ name: item.name }],
                history: [{ type: 'drawer', status: 'closed' }],
              }),
              target: state.key,
            })
          }}
          {...styles.menuItemsView(selected, template)}>
          <Box {...styles.imageContainerStyle}>
            {getMenuDetails?.image ? (
              <Icon id={getMenuDetails?.image as IconOptions} color={iconColour} size={20} />
            ) : (
              getMenuDetails.iconComp
            )}
          </Box>
          <Box ph={8} f={1}>
            <Text {...styles.menuTitile(selected, textColor)}>{getMenuDetails?.text ?? ''}</Text>
          </Box>
          {selected && RightArrow}
          {getMenuDetails?.rightComp}
          {MobileRightArrow}
        </Box>
        {!selected && (section.title === 'PREFERRED PAYMENT OPTION' || index !== section.data.length - 1) && (
          <Box backgroundColor={textColor as ColorOptions} height={1} marginLeft={56} opacity={0.2} />
        )}
        <Box {...styles.coverView(isRowFlex, selected)} />
      </Box>
    )
  }

  const onToggleSwitch = (isOn: boolean) => {
    console.log('onToggleSwitch isOn', isOn)
    updateIsSubscriptionEnabled(isOn)
  }

  // const onSelectSwitch = (val: number) => {
  //   console.log('onToggleSwitch1 isOn', val)
  // }

  return (
    <Box {...styles.menuView(template, theme)} flex={1}>
      <>
        <Box
          p={18}
          height={48}
          justifyContent="space-between"
          bg={convertHexToRGBA(brandColor, 10) as ColorOptions}
          flexDirection="row">
          <Text {...styles.title(textColor)}>{isSubscriptionEnabled ? 'SUBSCRIPTION AMOUNT' : 'AMOUNT PAYABLE'}</Text>
          <Text testID={'amount-payable'} fontSize={16} fontFamily={'jioType-medium'} color={textColor as ColorOptions}>
            ₹ {addTwoDecimalZeroes(isSubscriptionEnabled ? String(ruleAmount) : netAmount)}
          </Text>
        </Box>
        <Spacer size={16} />
      </>
      {allowPurchase && !isOfferApplied && (
        <CustomSwitch isOn={isSubscriptionEnabled} theme={theme} onToggleSwitch={onToggleSwitch} />
      )}
      <ViewOffer navigation={navigation} state={state} />

      {/* <ToggleSwitch isOn={isSubscriptionEnabled} theme={theme} tenure={'3 Months'} onToggleSwitch={onToggleSwitch} /> */}

      <SectionList
        contentContainerStyle={{ zIndex: 1, overflow: 'scroll' }}
        sections={sectionData}
        keyExtractor={(_, index) => `filterData_${index}`}
        data={sectionData}
        renderSectionHeader={renderSectionHeader}
        renderItem={renderItem}
        bounces={false}
      />

      {/*
      state.routes.map((route: any, index: any) => {
        const getMenuDetails = getMenuIconID(route.name as keyof Screens)
        const isSelected = state.routeNames[state.index] === route.name

        let type: ArcTypes
        if (isRowFlex) {
          type = index ? ArcTypes.TOP_RIGHT : ArcTypes.FLAT_TOP_RIGHT
        } else {
          type = index ? ArcTypes.TOP_LEFT : ArcTypes.FLAT_TOP_LEFT
        }
        const selected = isSelected && false

        const iconColour = brandColor as ColorOptions
        return (
          <Box key={route.key} {...styles.menuViewContainer(index === 0)}>
            <ArcView type={type} hide={!selected} />
            <Box
              testID={`paymentOption${index}`}
              underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
              onPress={() => {
                if (isLoadAndPay) {
                  updateIsLoadAndPay(false)
                  deleteSavedCards()
                }
                navigation.dispatch({
                  ...CommonActions.reset({
                    index: 0,
                    routes: [{ name: route.name }],
                  }),
                  target: state.key,
                })
              }}
              {...styles.menuItemsView(selected, template)}>
              <Box {...styles.imageContainerStyle}>
                {getMenuDetails?.image ? (
                  <Icon id={getMenuDetails?.image as IconOptions} color={iconColour} size={20} />
                ) : (
                  <UpiIcon size={24} selected={true} />
                )}
              </Box>
              <Box ph={8} f={1}>
                <Text {...styles.menuTitile(selected, textColor)}>{getMenuDetails?.text ?? ''}</Text>
              </Box>
              {selected && RightArrow}
              {!getMenuDetails?.image && UPIICON}
              {MobileRightArrow}
            </Box>
            {!selected && index !== state.routes.length - 1 && (
              <Box backgroundColor={textColor as ColorOptions} height={1} marginLeft={56} opacity={0.2} />
            )}
            <ArcView type={isRowFlex ? ArcTypes.BOTTOM_RIGHT : ArcTypes.BOTTOM_LEFT} hide={!selected} />
            <Box {...styles.coverView(isRowFlex, selected)} />
          </Box>
        )
      })
      */}

      <Footer isBottomAligned={false} isHomePage={true} />
    </Box>
  )
}

const CustomComp: FC = (props: any) => {
  const { updateRightHeaderClick, theme, template, isValidTemplate, getPaymentsSupportedTypes, isSubscriptionEnabled } =
    useStores((root) => ({
      updateRightHeaderClick: root.config.updateRightHeaderClick,
      theme: root?.config?.merchantTheme,
      template: root.merchant.template,
      isValidTemplate: root.isValidTemplate,
      getPaymentsSupportedTypes: root.getPaymentSupported,
      isSubscriptionEnabled: root.merchant.subscription.isEnabled,
    }))

  const paymentsSupported: any = getPaymentsSupportedTypes(isSubscriptionEnabled)
  const [item] = paymentsSupported.map((item: string) => {
    return item
  })

  const CompDetail = getPaymentModeList(item, template.id)

  const routeName = getPaymentMode(CompDetail.name)
  const [title, setTitle] = useState(getMenuIconID(routeName, theme?.brandColor).text)
  const [rightTitle, setRightTitle] = useState('')

  const homeRef: any = useRef(null)

  const handleback = () => {
    const routeName = getPaymentMode(CompDetail.name)
    if (title !== getMenuIconID(routeName, theme?.brandColor).text) {
      homeRef?.current?.goBack()
    } else {
      analyticsEvent('payment_mode_exit', { mode: routeEventMapper[name] })
      props.navigation.dispatch(DrawerActions.toggleDrawer())
    }
  }

  const onStateChange = (state: any) => {
    const currentRoute = state?.routes[state?.routes?.length - 1].name
    const title = HEADER[currentRoute]
    if (title) {
      if (title === HEADER.emicard) {
        setRightTitle('View all EMI Plans')
      }
      setTitle(title)
    } else {
      if (rightTitle) {
        setRightTitle('')
      }
      const routeName = getPaymentMode(CompDetail.name)
      setTitle(getMenuIconID(routeName, theme?.brandColor).text)
    }
  }

  const onClickRightHeader = () => {
    updateRightHeaderClick(true)
  }

  return (
    <Box nativeID="showListScrollBar" {...styles.menuContentView(theme)}>
      {!isValidTemplate(template?.id) && (
        <Header
          title={title}
          rightTitle={rightTitle}
          showGoBack={false}
          onGoBack={handleback}
          theme={theme}
          onClickRightHeader={onClickRightHeader}
        />
      )}
      <CompDetail.comp {...props} navigationRef={homeRef} onStateChange={onStateChange} />
    </Box>
  )
}

const CustomComponent: FC = (props: any) => {
  const { route } = props

  const { theme, updateRightHeaderClick } = useStores((root) => ({
    isInitialLoadComplete: root.config.isInitialLoadComplete,
    theme: root?.config?.merchantTheme,
    updateRightHeaderClick: root.config.updateRightHeaderClick,
  }))

  const routeName = getPaymentMode(route.name)
  const { comp: Component, name, header = true } = getPaymentModeList(routeName)
  const homeRef: any = useRef(null)
  const { desktopHeaderText, text, imagepath }: any = getMenuIconID(routeName, theme?.brandColor)
  const headerForDesktop = !isMobileDevice() ? desktopHeaderText ?? text : text
  const [title, setTitle] = useState(headerForDesktop)
  const [rightTitle, setRightTitle] = useState('')

  const handleback = () => {
    //const routeName = getPaymentMode(name)
    const titleDisplayed = headerForDesktop

    if (title !== titleDisplayed) {
      homeRef?.current?.goBack()
    } else {
      props.navigation.dispatch(DrawerActions.toggleDrawer())
    }
  }

  const onStateChange = (state: any) => {
    const currentRoute = state?.routes[state?.routes?.length - 1].name
    const currentParams = state?.routes[state?.routes?.length - 1].params
    const title = HEADER[currentRoute]
    console.log('test onStateChange', title)
    if (currentRoute === 'emiSavedCard' || currentRoute === pages.progress) {
      setTitle('')
    } else if (title) {
      if (title === HEADER.emicard) {
        setRightTitle('View all EMI Plans')
      }
      if (currentParams?.schemeSubType === '01') {
        setTitle(HEADER.emicardDc)
      } else {
        setTitle(title)
      }
    } else {
      if (rightTitle) {
        setRightTitle('')
      }
      const routeName = getPaymentMode(name)
      setTitle(getMenuIconID(routeName, theme?.brandColor).text)
    }
  }

  const onClickRightHeader = () => {
    updateRightHeaderClick(true)
  }

  return (
    <Box nativeID="showListScrollBar" {...styles.menuContentView(theme)}>
      <Header
        title={title}
        rightTitle={rightTitle}
        hide={!header || title === ''}
        onGoBack={handleback}
        theme={theme}
        imagepath={imagepath}
        onClickRightHeader={onClickRightHeader}
      />
      <Suspense fallback={<FallbackScreen />}>
        <Component {...props} setScreenName={setTitle} navigationRef={homeRef} onStateChange={onStateChange} />
      </Suspense>
    </Box>
  )
}

const CustomTemplateComponent: FC = (props: any) => {
  const { route } = props

  const { theme, template } = useStores((root) => ({
    isInitialLoadComplete: root.config.isInitialLoadComplete,
    theme: root?.config?.merchantTheme,
    template: root.merchant.template,
  }))

  console.log('CustomTemplateComponent route.name', route.name)
  const routeName = getPaymentMode(route.name)
  console.log('CustomTemplateComponent routeMapping', routeName)
  const CompDetail = getPaymentModeList(routeName, template.id)

  console.log('CustomTemplateComponent CompDetail', CompDetail)
  const homeRef: any = useRef(null)

  const [rightTitle, setRightTitle] = useState('')

  const onStateChange = (state: any) => {
    const currentRoute = state?.routes[state?.routes?.length - 1].name
    console.log('currentRoute', currentRoute)
    const title = HEADER[currentRoute]
    if (title) {
      if (title === HEADER.emicard) {
        setRightTitle('View all EMI Plans')
      }
    } else {
      if (rightTitle) {
        setRightTitle('')
      }
    }
  }

  return (
    <Box nativeID="showListScrollBar" {...styles.menuContentView(theme)}>
      <Box height={2} backgroundColor={theme?.brandColor as ColorOptions} />
      <Suspense fallback={<FallbackScreen />}>
        <CompDetail.comp {...props} navigationRef={homeRef} onStateChange={onStateChange} />
      </Suspense>
    </Box>
  )
}

const Drawer = createDrawerNavigator()
type Props = Partial<ComponentProps<typeof Drawer.Navigator>> & StackScreenProps<ParamListBase>

export const DrawerScreen = ({ route, navigation, ...rest }: Props) => {
  const template = useTemplate()

  useLayoutEffect(() => {
    navigation.setOptions({
      gestureEnabled: false,
    })
  }, [navigation])

  const {
    getPaymentsSupportedTypes,
    theme,
    isSinglePaymentModeAllowed,
    isSubscriptionEnabled,
    merchantTemplate,
    isValidTemplate,
    isDirectPayment,
    setSelectedPayment,
    getHeaderTitle,
    intentId,
    addPaymentMethod,
    confirmPayment,
    uniqueWindowId,
    hideHeaderCloseIcon,
    checkPaymentStatus,
    paymentStatus,
    txnId,
    callIntentStatusApi,
    redirectUrl,
    updateIntentStatusApi,
  } = useStores((root) => ({
    uniqueWindowId: root.config.uniqueWindowId,
    amount: root.transaction.amount,
    appaccesstoken: root.transaction.id.appaccesstoken,
    merchantApi: root.merchantApi,
    getClientIp: root.getClientIpApi,
    getPaymentsSupportedTypes: root.getPaymentSupported,
    isSubscriptionEnabled: root.merchant.subscription.isEnabled,
    theme: root?.config?.merchantTheme,
    isSinglePaymentModeAllowed: root.merchant.isSinglePaymentModeAllowed,
    merchantTemplate: root.merchant.template,
    isValidTemplate: root.isValidTemplate,
    isDirectPayment: root.isDirectPayment,
    setSelectedPayment: root.setSelectedPayment,
    getHeaderTitle: root.getHeaderTitle,
    intentId: root.transaction.id.intentId,
    addPaymentMethod: root.transaction.addPaymentMethod,
    confirmPayment: root.confirmPaymentApi,
    hideHeaderCloseIcon: root.config.hideHeaderCloseIcon,
    checkPaymentStatus: root.getIntentStatusApi,
    paymentStatus: root.transaction.paymentStatus,
    txnId: root.transaction.id.id,
    callIntentStatusApi: root.transaction.callIntentStatusApi,
    redirectUrl: root.transaction.getMerchantRedirectingUrl(),
    updateIntentStatusApi: root.transaction.updateIntentStatusApi,
  }))

  const [checkPaymentStatusApi, { state: checkPaymentStatusState }] = useLazyApiData(checkPaymentStatus)

  const NavigateToMerchant = useCallback(() => {
    if (isIFrame()) {
      window.parent.postMessage(
        {
          txnId: txnId ?? 0,
          intentId,
          status: 'completed',
          message: '',
          rUrl: redirectUrl,
        },
        '*',
      )
    } else {
      window.location.href = redirectUrl
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intentId, redirectUrl])

  // useEffect(() => {
  //   if (callIntentStatusApi) {
  //     checkPaymentStatusApi(true)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [callIntentStatusApi])

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | any

    if (callIntentStatusApi) {
      if (checkPaymentStatusState === 'fulfilled' && (paymentStatus === 'SUCCESS' || paymentStatus === 'FAILED')) {
        updateIntentStatusApi(false)
        NavigateToMerchant()
      } else {
        timeout = setTimeout(() => {
          // call intent status API until QR exires for every 5 sec
          checkPaymentStatusApi(true)
        }, 5000)
      }
    } else {
      // qr might be expired
      clearTimeout(timeout)
    }
    return () => clearTimeout(timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkPaymentStatusState, callIntentStatusApi])

  let headerTitle = ''
  if (isValidTemplate(merchantTemplate?.id)) {
    const routes: any = route
    const routeSymbol: any = Object.getOwnPropertySymbols(route)
    const childRoutes = routes[routeSymbol[0]]?.routes
    if (childRoutes) {
      if (childRoutes?.length === 1) {
        const paymentMode = getPaymentMode(childRoutes[0]?.name)
        headerTitle = getHeaderTitle(paymentMode)
      } else {
        headerTitle = 'Choose Payment Method'
      }
    } else {
      const childRoutes = routes?.state?.routes
      if (childRoutes?.length === 1) {
        const paymentMode = getPaymentMode(childRoutes[0]?.name)
        headerTitle = getHeaderTitle(paymentMode)
      } else {
        headerTitle = 'Choose Payment Method'
      }
    }
  }
  const [isConfirmCalled, setIsConfirmCalled] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(true)
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)
  const [confirmPaymentApi, { state: confirmPaymentState, data: confirmPaymentData }] = useLazyApiData(confirmPayment)

  const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env

  const paymentsSupported: any = getPaymentsSupportedTypes(isSubscriptionEnabled)

  console.log('paymentsSupportedz', paymentsSupported)

  useEffect(() => {
    if (confirmPaymentState === 'fulfilled') {
      navigation.reset({
        index: 0,
        routes: [{ name: pages.progress }],
      })
    } else if (confirmPaymentState === 'rejected') {
      const response = confirmPaymentData
      navigation.navigate(pages.ErrorView, { title: 'Error occurred', error: response?.message, rUrl: redirectUrl })
    }
  }, [confirmPaymentData, confirmPaymentState, navigation])

  console.log('showPaymentProcessModal', showPaymentProcessModal)
  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      try {
        window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
        window.currentChild?.focus()
      } catch (e) {
        window.parent.postMessage(
          {
            txnId: 0,
            intentId,
            status: 'error',
            message: 'Not supported direct payment in inframe checkout',
          },
          '*',
        )
      }
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, intentId, uniqueWindowId])

  useEffect(() => {
    if (paymentsSupported.length !== 0) {
      analyticsEvent('payment_page_load')
    }
  }, [paymentsSupported.length])

  if (paymentsSupported.length === 0) {
    return null
  }

  const handleProceed = (paymentType: number, data: any) => {
    setIsConfirmCalled(true)
    if (paymentType === PAYMENT_MODE_SUBTYPES.NB) {
      const bankId = data?.bankId ?? ''
      setSelectedPayment(String(bankId), PAYMENT_MODE_SUBTYPES.NB)
      loadProcessingScreen()
    } else if (paymentType === PAYMENT_MODE_SUBTYPES.CARD) {
      const { cvv, vaultId } = data
      const newCard = {
        number: '',
        type: 'CREDITCARD',
        subType: '',
        cvv: cvv,
        scheme: '',
        token: vaultId,
        ownerName: '',
        expmon: 0,
        expyr: 0,
        expDate: '',
        id: 0,
        paymentType: 'Card',
      } as CardType
      addPaymentMethod(newCard)
      loadProcessingScreen()
    } else if (paymentType === PAYMENT_MODE_SUBTYPES.FOOD_CARD) {
      const { vaultId } = data
      const newCard = {
        number: '',
        type: 'FOODCARD',
        subType: '',
        cvv: '',
        scheme: '',
        token: vaultId,
        ownerName: '',
        expmon: 0,
        expyr: 0,
        expDate: '',
        id: '',
        paymentType: 'FoodCard',
      }
      addPaymentMethod(newCard)

      loadProcessingScreen()
    } else if (paymentType === PAYMENT_MODE_SUBTYPES.UPI) {
      const upi = {
        id: 0,
        vpa: data.vpa,
        paymentType: 'UPI',
        isSave: false,
      } as UPIType
      addPaymentMethod(upi)
      confirmPaymentApi()
    }
  }

  const { isPay, type, data } = isDirectPayment()
  if (isPay) {
    return (
      <>
        {!isConfirmCalled && handleProceed(Number(type), data)}
        {confirmPaymentState === 'pending' && (
          <Box {...styles.loadingStyle(theme.bodyBgColor)}>
            <Loader type="small" color={theme.brandColor as ColorOptions} />
            <Spacer size={8} />
          </Box>
        )}

        {showPaymentProcessModal && (
          <>
            <MobileProcessing
              setShow={setShowPaymentProcessModal}
              show={showPaymentProcessModal}
              isFoodCard={type === String(PAYMENT_MODE_SUBTYPES.FOOD_CARD)}
            />
          </>
        )}
      </>
    )
  }

  if (isSinglePaymentModeAllowed()) {
    const [item] = paymentsSupported.map((item: string) => {
      return item
    })

    const CompDetail = getPaymentModeList(item, merchantTemplate.id)
    return (
      <>
        {isValidTemplate(merchantTemplate?.id) && <TOneHeader subTitle={CompDetail.title} />}
        {!isValidTemplate(merchantTemplate?.id) && <MainHeader />}
        <Box {...styles.container(theme?.bodyBgColor)}>
          <>
            <PreventBack isDrawerOpen={isDrawerOpen} />
            <Box {...styles.containerInner(0)}>
              <CustomComp />
            </Box>
          </>
        </Box>
      </>
    )
  }

  if (isValidTemplate(merchantTemplate?.id)) {
    return (
      <>
        <TOneHeader subTitle={headerTitle} />
        <Box {...styles.container(theme?.bodyBgColor)}>
          <PreventBack isDrawerOpen={isDrawerOpen} />
          <Box {...styles.containerInner(0)}>
            <Drawer.Navigator
              defaultStatus={'open'}
              screenOptions={{
                drawerStyle: { width: '100%' },
                drawerPosition: template?.headerFlexDirection === 'row' ? 'left' : 'right',
                drawerType: 'back',
                overlayColor: 'transparent',
                sceneStyle: { backgroundColor: 'HALF_WHITE', flex: 1 },
              }}
              drawerContent={(props) => {
                setIsDrawerOpen(props.state.history.some((it: { type: string }) => it.type === 'drawer'))
                return <CustomDrawerContent {...props} />
              }}
              {...rest}>
              {[
                ...paymentsSupported.map((item: string, index: number) => {
                  const compDetail = getPaymentModeList(item)
                  return (
                    <Drawer.Screen
                      key={`${compDetail.name}_${index}`}
                      name={compDetail.name}
                      component={CustomTemplateComponent}
                      options={{ headerShown: false }}
                    />
                  )
                }),
                <Drawer.Screen
                  key={'offers'}
                  name={ROUTE_NAMES.offers}
                  component={Offers}
                  options={{ headerShown: false }}
                />,
              ]}
            </Drawer.Navigator>
          </Box>
        </Box>
      </>
    )
  }
  return (
    <>
      <MainHeader hideCloseIcon={hideHeaderCloseIcon} />
      <Box {...styles.container(theme?.bodyBgColor)}>
        <PreventBack isDrawerOpen={isDrawerOpen} />
        <Box {...styles.containerInner(0)}>
          <Drawer.Navigator
            defaultStatus={'open'}
            screenOptions={{
              drawerStyle: { width: '100%' },
              drawerPosition: template?.headerFlexDirection === 'row' ? 'left' : 'right',
              drawerType: 'back',
              overlayColor: 'transparent',
              sceneStyle: { backgroundColor: 'HALF_WHITE', flex: 1 },
            }}
            drawerContent={(props) => {
              setIsDrawerOpen(props.state.history.some((it: { type: string }) => it.type === 'drawer'))
              return <CustomDrawerContent {...props} />
            }}
            {...rest}>
            {[
              ...paymentsSupported.map((item: string, index: number) => {
                const compDetail = getPaymentModeList(item)
                return (
                  <Drawer.Screen
                    key={`${compDetail.name}_${index}`}
                    name={compDetail.name}
                    component={CustomComponent}
                    options={{ headerShown: false }}
                  />
                )
              }),
              <Drawer.Screen
                key={'offers'}
                name={ROUTE_NAMES.offers}
                component={Offers}
                options={{ headerShown: false }}
              />,
            ]}
          </Drawer.Navigator>
        </Box>
      </Box>
    </>
  )
}

const styles = {
  container: (bodyBgColor: any) =>
  ({
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: bodyBgColor,
  } as BoxProps),
  containerInner: (ph: any) =>
    ({ justifyContent: 'center', width: '100%', maxWidth: 820, paddingHorizontal: ph } as BoxProps),
  title: (textColor: any) =>
  ({
    fontSize: 12,
    letterSpacing: 1.1,
    color: convertHexToRGBA(textColor, 50) as ColorOptions,
    fontWeight: 'FONT_WEIGHT_MEDIUM',
    fontFamily: 'jioType-Medium',
  } as TextProps),
  loadingStyle: (bodyBgColor: any) =>
  ({
    // marginTop: 24,
    padding: 24,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: bodyBgColor as ColorOptions,
  } as BoxProps),
  labelText: (textColor: any) =>
  ({
    type: 'callout',
    color: textColor as ColorOptions,
    textAlign: 'center',
    fontFamily: 'jioType-medium',
  } as TextProps),
  menuView: (template: any, theme: any) =>
  ({
    marginTop: 0,
    zIndex: 2,
    right: template?.headerFlexDirection === 'row' ? 0 : undefined,
    left: template?.headerFlexDirection === 'row' ? undefined : 0,
    backgroundColor: theme?.bodyBgColor as ColorOptions,
  } as BoxProps),
  menuViewContainer: {
    zIndex: 1,
    // paddingHorizontal: 8,
    overflow: 'visible',
  } as BoxProps,
  menuItemsView: (isSelected: boolean, template: any) =>
  ({
    backgroundColor: isSelected ? 'WHITE' : undefined,
    flexDirection: template?.headerFlexDirection,
    borderColor: isSelected ? '#ccc' : 'TRANSPARENT',
    borderRightColor: 'TRANSPARENT',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 56,
    ...getBorder(template),
  } as BoxProps),
  menuTitile: (isSelected: boolean, textColor: any) =>
  ({
    color: isSelected ? 'PRIMARY' : (textColor as ColorOptions),
    type: 'body1',
    weight: isSelected ? 'dense' : 'FONT_WEIGHT_MEDIUM',
    lineHeight: 18,
    numberOfLines: 1,
    fontSize: 14,
    fontFamily: 'jioType-Medium',
  } as TextProps),
  imageContainerStyle: {
    paddingLeft: 16,
    paddingRight: 12,
    width: 56,
    justifyContent: 'center',
  } as BoxProps,
  imageStyle: {
    width: 50,
    height: 50,
  } as ImageProps,
  arrowContainerStyle: (template: any) =>
  ({
    ...(template?.headerFlexDirection === 'row' ? { right: 0 } : { left: 0 }),
    paddingHorizontal: 12,
    alignItems: 'center',
    paddingTop: 2,
    justifyContent: 'center',
  } as BoxProps),
  menuContentView: (theme: any) =>
  ({
    flex: 1,
    borderColor: 'GREY_1_SEPARATOR',
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: theme?.bodyBgColor as ColorOptions,
    minHeight: 100,
    overflowY: 'auto',
    ph: 0,
    zIndex: 1,
    marginTop: 0,
    marginBottom: 0,
  } as BoxProps),
  coverView: (isRowFlex: boolean, isSelected: boolean) =>
  ({
    backgroundColor: 'WHITE',
    position: 'absolute',
    width: 14,
    right: isRowFlex ? -2 : undefined,
    left: isRowFlex ? undefined : -2,
    top: 1,
    bottom: 1,
    opacity: isSelected ? 1 : 0,
  } as BoxProps),
}

const getBorder = (template: any) => {
  if (template?.headerFlexDirection === 'row') {
    return {
      borderBottomLeftRadius: 8,
      borderTopLeftRadius: 8,
      borderLeftWidth: 1,
      borderRightWidth: 1,
    }
  }
  return {
    borderBottomRightRadius: 8,
    borderTopRightRadius: 8,
    borderLeftWidth: 0,
    borderRightWidth: 1,
  }
}

export { DrawerScreen as PayStack }
export default DrawerScreen
